import { Text } from "../Text";
import cx from "classnames";
import styles from "./PaginationTotalCount.module.scss";

export const PaginationTotalCount = ({
  firstItem,
  lastItem,
  totalCount,
  className,
}: {
  firstItem: number;
  lastItem: number;
  totalCount: number;
  className?: string;
}) => {
  const paginationTotalCountClassName = cx(
    styles["pagination-total-count"],
    className,
  );
  return (
    <Text
      size="small"
      aria-live="polite"
      aria-atomic="true"
      className={paginationTotalCountClassName}
    >
      {firstItem} - {lastItem} {totalCount ? `of ${totalCount}` : ""} items
    </Text>
  );
};
